"use strict";
export var AppNotificationType = /* @__PURE__ */ ((AppNotificationType2) => {
  AppNotificationType2[AppNotificationType2["Default"] = 0] = "Default";
  AppNotificationType2[AppNotificationType2["Error"] = 1] = "Error";
  AppNotificationType2[AppNotificationType2["WalletConnect"] = 2] = "WalletConnect";
  AppNotificationType2[AppNotificationType2["Transaction"] = 3] = "Transaction";
  AppNotificationType2[AppNotificationType2["TransactionPending"] = 4] = "TransactionPending";
  AppNotificationType2[AppNotificationType2["Favorites"] = 5] = "Favorites";
  AppNotificationType2[AppNotificationType2["Copied"] = 6] = "Copied";
  AppNotificationType2[AppNotificationType2["CopyFailed"] = 7] = "CopyFailed";
  AppNotificationType2[AppNotificationType2["Success"] = 8] = "Success";
  AppNotificationType2[AppNotificationType2["NetworkChanged"] = 9] = "NetworkChanged";
  AppNotificationType2[AppNotificationType2["NetworkChangedBridge"] = 10] = "NetworkChangedBridge";
  AppNotificationType2[AppNotificationType2["ChooseCountry"] = 11] = "ChooseCountry";
  AppNotificationType2[AppNotificationType2["AssetVisibility"] = 12] = "AssetVisibility";
  AppNotificationType2[AppNotificationType2["SwapPending"] = 13] = "SwapPending";
  AppNotificationType2[AppNotificationType2["TransferCurrencyPending"] = 14] = "TransferCurrencyPending";
  AppNotificationType2[AppNotificationType2["ScantasticComplete"] = 15] = "ScantasticComplete";
  AppNotificationType2[AppNotificationType2["DappConnected"] = 16] = "DappConnected";
  AppNotificationType2[AppNotificationType2["DappDisconnected"] = 17] = "DappDisconnected";
  AppNotificationType2[AppNotificationType2["NotSupportedNetwork"] = 18] = "NotSupportedNetwork";
  AppNotificationType2[AppNotificationType2["PasswordChanged"] = 19] = "PasswordChanged";
  return AppNotificationType2;
})(AppNotificationType || {});
export var CopyNotificationType = /* @__PURE__ */ ((CopyNotificationType2) => {
  CopyNotificationType2["Address"] = "address";
  CopyNotificationType2["Unitag"] = "unitag";
  CopyNotificationType2["ContractAddress"] = "contractAddress";
  CopyNotificationType2["Calldata"] = "calldata";
  CopyNotificationType2["TransactionId"] = "transactionId";
  CopyNotificationType2["Image"] = "image";
  CopyNotificationType2["TokenUrl"] = "tokenUrl";
  CopyNotificationType2["BlockExplorerUrl"] = "blockExplorerUrl";
  CopyNotificationType2["NftUrl"] = "nftUrl";
  return CopyNotificationType2;
})(CopyNotificationType || {});
